var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgContactIcon = function SvgContactIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83335 12.8333H0.166687C0.166687 10.0718 2.40526 7.83325 5.16669 7.83325C7.92811 7.83325 10.1667 10.0718 10.1667 12.8333H8.50002C8.50002 10.9923 7.00764 9.49992 5.16669 9.49992C3.32574 9.49992 1.83335 10.9923 1.83335 12.8333ZM11.8284 9.84158L9.57335 7.59159L10.75 6.40992L11.8267 7.48658L15.41 3.90992L16.5867 5.08992L11.8267 9.83992L11.8284 9.84158ZM5.16669 6.99992C3.32574 6.99992 1.83335 5.50753 1.83335 3.66659C1.83335 1.82564 3.32574 0.333252 5.16669 0.333252C7.00764 0.333252 8.50002 1.82564 8.50002 3.66659C8.49772 5.50658 7.00668 6.99762 5.16669 6.99992ZM5.16669 1.99992C4.25618 2.00084 3.51493 2.73229 3.50188 3.6427C3.48883 4.55311 4.20882 5.3055 5.11893 5.33252C6.02903 5.35953 6.79238 4.65117 6.83335 3.74159V4.07492V3.66659C6.83335 2.74611 6.08716 1.99992 5.16669 1.99992Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContactIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contact-icon.09c3e060.svg";
export { ForwardRef as ReactComponent };